module.exports = __webpack_public_path__ + "img/wndlq_img.8035cfff.png";